// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__tkOPg","Bookstore":"Header_Bookstore__omRfH","navbar":"Header_navbar__Gew18","navul":"Header_navul__d6d5X","icon":"Header_icon__V9Fg3"};